/** 紧急程度使用醒目的实底标签：原白底小圆点不够明显，改为亮橙/红底、加粗文字和强调符号。
 * 正常灰色、紧急橙色深字、非常紧急红色白字；兼顾文字对比度，工种底色与施工状态仍独立。
 */
import React from "react";

export const SCHEDULE_PRIORITIES = {
  normal: { zh: "正常", en: "Normal", borderColor: "#94a3b8", style: "bg-slate-200 text-slate-700 border-slate-300" },
  urgent: { zh: "紧急", en: "Urgent", borderColor: "#f97316", style: "bg-orange-500 text-slate-950 border-orange-600", mark: "!" },
  critical: { zh: "非常紧急", en: "Very urgent", borderColor: "#dc2626", style: "bg-red-600 text-white border-red-700", mark: "!!" },
};

/** 未设置级别的历史任务统一显示正常，避免未知值误显示最高优先级。 */
export const schedulePriority = (value) => Object.prototype.hasOwnProperty.call(SCHEDULE_PRIORITIES, value) ? SCHEDULE_PRIORITIES[value] : SCHEDULE_PRIORITIES.normal;

/** 月历窄格仅显示色块和简称，避免符号挤掉文字；完整标签增加强调符号，title 保留全称。 */
export default function SchedulePriority({ value, zh = true, compact = false }) {
  const priority = schedulePriority(value);
  return <span data-testid="schedule-priority-badge" title={zh ? priority.zh : priority.en} className={`inline-flex max-w-full items-center gap-1 rounded-md border font-bold leading-tight ${compact ? "px-1 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"} ${priority.style}`}>
    {!compact && priority.mark && <span aria-hidden="true" className="shrink-0 font-black">{priority.mark}</span>}<span className="truncate">{zh ? (compact && value === "critical" ? "特急" : priority.zh) : priority.en}</span>
  </span>;
}
